import React, { Component, Fragment } from "react";
import { ApiClient } from "@solarschools/api-sdk";
import Graph from "@solarschools/component-lib/components/WaterGraph";
import HeatMap from "@solarschools/component-lib/components/ReversedCalendarHeatMap";
import { autoFormatVolumeValue } from "@solarschools/component-lib/utilities/VolumeUnits";
import LoadingDots from "../LoadingDots/LoadingDots";
import { parse, addHours, addDays, format } from "date-fns";
import NoDataAvailable from "../NoDataAvailable";
import DataApi from "@solarschools/api-sdk/dist/api/DataApi";

class WaterGraph extends Component {
  // TODO: integrate the revised components
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      lifetime: [{ localDate: new Date(), usage: 0 }],
      day: [],
      selectedDate: new Date(),
      graphLoading: false,
    };

    this.handleDateCLick = this.handleDateCLick.bind(this);
  }

  async handleDateCLick({ localDate }) {
    const parsedDate = parse(localDate, "yyyy-MM-dd", new Date());
    this.setState({ graphLoading: true, selectedDate: parsedDate });
    await this.loadDayData(parsedDate);
    this.setState({ graphLoading: false });
  }

  async componentDidMount() {
    await Promise.all([this.loadLifetimeData(), this.loadDayData()]);
    this.setState({ loading: false });
  }

  async loadLifetimeData() {
    try {
      const Client = ApiClient.instance;
      Client.defaultHeaders = {};
      Client.basePath = "https://api.solarschools.net/v1".replace(/\/+$/, "");
      let dataApi = new DataApi(Client);
      let id = 433;
      const { data } = await dataApi.getWaterStats('sites', id);
      this.setState({ lifetime: data });
    } catch (error) {
      console.error(error);
    }
  }

  async loadDayData(date = new Date()) {
    try {
      const Client = ApiClient.instance;
      Client.defaultHeaders = {};
      Client.basePath = "https://api.solarschools.net/v1".replace(/\/+$/, "");
      let dataApi = new DataApi(Client);
      let id = 433;
      const end = format(addDays(date, 1), "yyyy-MM-dd");
      const start = format(date, "yyyy-MM-dd");
      const { data = [] } = await dataApi.getWaterFeed('sites', id, end, start);
      const day = data.map((d) => ({
        consumption: d.consumption,
        time: d.time,
      }));
      this.setState({ day });
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    return (
      <div className="card w-100 bg-white border-none mb-5 px-0">
        <div className="box-content bg-white text-secondary p-4 p-sm-5">
          {this.state.loading ? (
            <h2 className="ss-title">Loading Water Consumption Data</h2>
          ) : (
            <Fragment>
              <h2 className="ss-title px-0 pb-4">
                <strong>Water Consumption</strong>

                {/* <small>
                  {" "}
                  - {format(this.state.selectedDate, "MMM dd, yyyy")}
                </small> */}
              </h2>
              {this.state.graphLoading ? (
                <div className="aspect-ratio aspect-ratio-21by9">
                  <div className="aspect-ratio-content">
                    <div className="h-100 d-flex flex-row align-items-center justify-conent-center">
                      <LoadingDots spinnerClass="bg-primary" />
                    </div>
                  </div>
                </div>
              ) : this.state.day.length > 1 ? (
                <Graph data={this.state.day} aspectRatio="21by9" />
              ) : (
                <NoDataAvailable />
              )}
              <HeatMap
                dateKey="localDate"
                dataKey="consumed"
                data={this.state.lifetime}
                maximumColor="#2492d2"
                themeColor="#3193D0"
                months={12}
                title="Daily Water Usage"
                tagline=""
                category="Water Usage"
                hasTooltip={false}
                clickHandler={this.handleDateCLick}
                transformUnit={autoFormatVolumeValue}
              />
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default WaterGraph;



// WEBPACK FOOTER //
// ./resources/assets/js/app/WaterGraph/index.js